import {Component} from '@angular/core'

@Component({
  selector: 'pluto-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
}

